import script from "./PhoneWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhoneWidget.vue?vue&type=script&setup=true&lang=ts"

import "./PhoneWidget.vue?vue&type=style&index=0&id=2b405562&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b405562"]])

export default __exports__